import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'custName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'empUserId',
      type: 'input',
      label: '企微号',
      placeholder: '请输入企微号'
    },
    {
      field: 'usedBy',
      type: 'input',
      label: '使用人',
      placeholder: '请输入使用人'
    },
    {
      field: 'deptName',
      type: 'select',
      label: '所属部门',
      placeholder: '请选择所属部门',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'corpName',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'stockYearLimit',
      type: 'select',
      label: '炒股年限',
      placeholder: '请选择炒股年限',
      clearable: true,
      options: [
        { title: '1年以下', value: '1' },
        { title: '1年-3年', value: '2' },
        { title: '3年以上', value: '3' }
      ]
    },
    {
      field: 'fundScale',
      type: 'select',
      label: '资金规模',
      placeholder: '请选择资金规模',
      clearable: true,
      options: [
        { title: '10万以下', value: '1' },
        { title: '10万以上', value: '2' }
      ]
    },
    {
      field: 'longShortLine',
      type: 'select',
      label: '长/短线',
      placeholder: '请选择长/短线',
      clearable: true,
      options: [
        { title: '小于1周', value: '1' },
        { title: '小于1个月', value: '2' },
        { title: '小于半年', value: '3' },
        { title: '半年以上', value: '4' }
      ]
    },
    {
      field: 'operationStyle',
      type: 'select',
      label: '操作风格',
      placeholder: '请选择操作风格',
      clearable: true,
      options: [
        { title: '追逐热点', value: '1' },
        { title: '底部潜伏', value: '2' },
        { title: '顺势交易', value: '3' },
        { title: '组合买入', value: '4' }
      ]
    }
  ]
}
